import React from "react";

const s = { stroke: "#1a2744", strokeWidth: "1.5", fill: "none" };
const sr = { stroke: "#c0392b", strokeWidth: "1.5", fill: "none" };

export const IconSearch = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" {...s}/>
    <path d="M16.5 16.5L21 21" {...s} strokeLinecap="round"/>
  </svg>
);

export const IconBack = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M19 12H5M5 12L12 19M5 12L12 5" {...s} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconZoom = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" stroke="white" strokeWidth="1.5"/>
    <path d="M16.5 16.5L21 21" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 11h6M11 8v6" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconNoListing = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="8" height="8" rx="1.5" {...s}/>
    <path d="M14 7h7M14 12h7M3 17h18" {...s} strokeLinecap="round"/>
  </svg>
);

export const IconChat = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" {...s} strokeLinejoin="round"/>
  </svg>
);

export const IconEdit = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" {...s} strokeLinecap="round"/>
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" {...s} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconFlag = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" {...sr} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 22v-7" {...sr} strokeLinecap="round"/>
  </svg>
);

export const IconHeart = ({ filled }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={filled ? "#c0392b" : "none"}>
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke={filled ? "#c0392b" : "#1a2744"} strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

export const IconCamera = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" {...s} strokeLinejoin="round"/>
    <circle cx="12" cy="13" r="4" {...s}/>
  </svg>
);

export const IconEmptyBox = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="3" width="20" height="14" rx="2" {...s}/>
    <path d="M8 21h8M12 17v4" {...s} strokeLinecap="round"/>
  </svg>
);

export const IconEmptyCheck = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" {...s} strokeLinecap="round"/>
    <path d="M22 4L12 14.01l-3-3" {...s} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconEmptyHeart = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" {...s} strokeLinejoin="round"/>
  </svg>
);

export const IconEmptySearch = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="7" {...s}/>
    <path d="M16.5 16.5L21 21" {...s} strokeLinecap="round"/>
  </svg>
);
